'use client'

import { useAmplitudeAnalytics } from '@/src/hooks/use-amplitude-analytics'
import { PageViewed, type PageViewedProperties } from '../codegen/ampli'

/**
 * In Next.js's App Router, we cannot call Amplitude analytics functions on the server side.
 * Because we need to use "use client", which requires a separate client component,
 * we created this component to log page views.
 * */
const LogPageEvent = (props: PageViewedProperties) => {
  useAmplitudeAnalytics({
    onMountEvent: new PageViewed(props),
  })

  return null
}

export default LogPageEvent
